export default function applyLanguageToDocument(lang) {
  const isArabic = lang === "AR";
  document.documentElement.dir = isArabic ? "rtl" : "ltr";
  document.documentElement.lang = isArabic ? "ar" : "en";
  document.body.classList.toggle("arabic-version", isArabic);
}

